module.exports = __webpack_public_path__ + "static/media/parceiro(1).ff2d5aa8.png";